import React from 'react';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import DateHelpers from 'helpers/DateHelpers';

// Components
import SpecialAvailabilityModal from 'components/instructor/SpecialAvailabilityModal';

//-------------------------------------------------------------------------------------------------------------------

class AvailabilitySelector extends React.Component {

    constructor(props) {
        super(props);

        this.specialAvailabilityModalRef = React.createRef();
    }

    async showSpecialAvailabilityModal(week, date, numDays) {
        let specialAvailabilityType, notes, hasMultipleTypes = false, hasMultipleNotes = false;
        let currDate = moment(date || week.weekCommencing);

        // Get existing values, and if we're looking at a week, check for multiple conflicting values
        for (let i = 0; i < numDays; i++) {
            const dateKey = DateHelpers.getDateKey(currDate);
            const newSpecialAvailabilityType = week.specialAvailabilityDates[dateKey];
            const newNotes = week.notes[dateKey];
            if (specialAvailabilityType) {
                if (newSpecialAvailabilityType != specialAvailabilityType) {
                    hasMultipleTypes = true;
                }
            } else {
                specialAvailabilityType = newSpecialAvailabilityType;
            }
            if (notes) {
                if (newNotes != notes) {
                    hasMultipleNotes = true;
                }
            } else {
                notes = newNotes;
            }
            currDate.add(1, 'day');
        }

        const result = await this.specialAvailabilityModalRef.current.show({
            date,
            specialAvailabilityType,
            notes,
            hasMultipleTypes,
            hasMultipleNotes
        });
        this.props.setSpecialAvailabilityType(week.weekCommencing, date, numDays, result.specialAvailabilityType, result.notes);
    }

    render() {
        const {
            availability,
            workingDays,
            isScrollable
        } = this.props;

        return (<>
            <div className={isScrollable ? 'sticky-table-container scrolling' : ''}>

                <table className="table sticky-table availability-selector">
                    <thead>
                        <tr>
                            <th className="sticky-column">Week</th>
                            {workingDays.map(dow =>
                                <th key={dow}>
                                    {dow}
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {availability.weeks.map(week => this.renderWeek(week))}
                    </tbody>
                </table>

            </div>

            <SpecialAvailabilityModal ref={this.specialAvailabilityModalRef} />

        </>);
    }

    renderWeek(week) {
        const {
            onUpdateAvailability,
            setSpecialAvailabilityType,
            workingDays
        } = this.props;
        let areAllDatesAvailable = true;
        const loginInfo = GlobalStateService.getValue('loginInfo');

        // Get a list of dates based on this week and working day list
        const dates = [];
        const date = moment(week.weekCommencing);
        workingDays.forEach(dow => {
            while (date.format('dddd') != dow) {
                date.add(1, 'day');
            }
            dates.push(date.toDate());

            // Determine if all dates this week are available or not
            const key = DateHelpers.getDateKey(date);
            if (!week.availableDates[key] && !week.bookings[key] && !week.pendingApprovalDates[key]) {
                areAllDatesAvailable = false;
            }
        });

        // Render
        return (
            <tr key={week.weekCommencing}>
                <th>
                    <div className="week-number">
                        {week.weekNumber}
                    </div>
                    <div className="week-commencing">
                        W/C{' '}
                        {moment(week.weekCommencing).format('DD/MM/YYYY')}
                    </div>

                    {onUpdateAvailability &&
                        <button className="btn btn-sm btn-secondary mt-2 hover-btn" onClick={e => onUpdateAvailability(week.weekCommencing, null, 7, !areAllDatesAvailable)}>
                            Make {areAllDatesAvailable ? 'unavailable' : 'available'}
                        </button>
                    }

                    {loginInfo.isAdmin && setSpecialAvailabilityType &&
                        <button className="btn special-availability-button" onClick={() => this.showSpecialAvailabilityModal(week, null, 7)}>
                            <span className="fa-solid fa-plus" />
                        </button>
                    }

                </th>
                {dates.map(date => {
                    const dateKey = moment(date).format('YYYYMMDD');
                    const isHighlighted = this.props.highlightDates && this.props.highlightDates.find(d => moment(d).format('YYYYMMDD') == dateKey);
                    return (
                        <td key={date}>
                            <div className={'cell-inner ' + (isHighlighted ? 'highlighted' : '')}>
                                {this.renderDate(week, date)}
                            </div>
                        </td>
                    )}
                )}
            </tr>
        );
    }

    renderDate(week, date) {
        const {
            onUpdateAvailability,
            setSpecialAvailabilityType,
            onViewBooking,
            ignoreLocked
        } = this.props;
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const dateKey = DateHelpers.getDateKey(date);
        const booking = week.bookings[dateKey];
        const isAvailable = !!week.availableDates[dateKey];
        let isDefinitelyNotAvailable, isStealthVendor, isStealthOther;
        const isSpecialAvailability = !week.availableDates[dateKey] && !!week.specialAvailabilityDates[dateKey];
        if (isSpecialAvailability) {
            isDefinitelyNotAvailable = week.specialAvailabilityDates[dateKey] == 'DefinitelyNotAvailable';
            isStealthVendor = week.specialAvailabilityDates[dateKey] == 'StealthVendor';
            isStealthOther = week.specialAvailabilityDates[dateKey] == 'StealthOther';
        }
        const isLocked = !ignoreLocked && !!week.lockedDates[dateKey];
        const isPendingApproval = !!week.pendingApprovalDates[dateKey];

        if (booking) {
            return (
                <div className={`instructor-status ${booking.status.toLowerCase()} ${isLocked ? 'locked' : ''}`}>

                    <div className="status-header">
                        {moment(date).format('DD/MM/YYYY')}
                    </div>

                    <div className="status-body">
                        {booking.status}{booking.isATPBooking ? ' (ATP)' : ''}
                        {booking.lmsid && <>
                            <br />
                            {booking.isATPBooking ? 'Booking ref' : 'LMS ID'}: {booking.lmsid}
                        </>}
                    </div>

                    {loginInfo.isAdmin && onViewBooking &&
                        <button className="btn btn-sm hover-btn" onClick={e => onViewBooking(booking.id)}>
                            View booking
                        </button>
                    }
                </div>
            );
        }
        else if (isAvailable || isPendingApproval) {
            return (
                <div className={'instructor-status available ' + (isLocked ? 'locked' : '') + ' ' + (isPendingApproval ? 'pending-approval' : '')}>

                    <div className="status-header">
                        {moment(date).format('DD/MM/YYYY')}
                    </div>

                    <div className="status-body">
                        Available
                        {isPendingApproval && <><br/>(Pending removal)</>}
                    </div>

                    {!isPendingApproval && onUpdateAvailability &&
                        <button className="btn btn-sm btn-secondary hover-btn mt-2" onClick={e => onUpdateAvailability(week.weekCommencing, date, 1, false)}>
                            Make unavailable
                        </button>
                    }

                </div>
            );
        } else {
            let className = '', content = 'Unavailable';
            if (isDefinitelyNotAvailable) {
                className = 'definitely-not-available';
                content = <>DEFINITELY <br /> NOT AVAILABLE</>;
            }
            else if (isStealthVendor) {
                className = 'stealth-date';
                content = <>Stealth available <br /> (Vendor)</>;
            }
            else if (isStealthOther) {
                className = 'stealth-date';
                content = <>Stealth available <br /> (Other)</>;
            }

            return (
                <div className={'instructor-status unavailable ' + (isLocked ? 'locked' : '') + ' ' + className}>

                    {loginInfo.isAdmin && setSpecialAvailabilityType &&
                        <button
                            className="btn special-availability-button"
                            onClick={() => this.showSpecialAvailabilityModal(week, date, 1)}
                        >
                            <span className="fa-solid fa-plus" />
                        </button>
                    }

                    {!!week.notes[dateKey] &&
                        <span className="fa fa-comment availability-notes-icon" title={week.notes[dateKey]} />
                    }
                    
                    <div className="status-header">
                        {moment(date).format('DD/MM/YYYY')}
                    </div>

                    <div className="status-body">
                        {content}
                    </div>

                    {onUpdateAvailability && !isSpecialAvailability &&
                        <button className="btn btn-secondary btn-sm hover-btn mt-2" onClick={e => onUpdateAvailability(week.weekCommencing, date, 1, true)}>
                            Make available
                        </button>
                    }

                </div>
            );
        }
    }
}

export default AvailabilitySelector;